import { usePillTabsIndicator } from './hooks';
import { getContainerStyle } from './styles';
import { PillTabItem } from './PillTabItem';
import { PillTabIndicator } from './PillTabIndicator';

interface Tab {
  label: string;
  value: string;
  icon?: JSX.Element;
}

interface PillTabsProps {
  tabs: Tab[];
  currentTab: string;
  onTabChange: (value: string) => void;
  fullWidth?: boolean;
}

export const PillTabs = ({
  tabs,
  currentTab,
  onTabChange,
  fullWidth
}: PillTabsProps) => {
  const { containerRef, tabRefs, indicatorStyle } = usePillTabsIndicator(
    tabs,
    currentTab
  );

  return (
    <div ref={containerRef} style={getContainerStyle(fullWidth)}>
      <PillTabIndicator
        left={indicatorStyle.left}
        width={indicatorStyle.width}
        height={indicatorStyle.height}
      />
      {tabs.map((tab, index) => (
        <PillTabItem
          key={tab.value}
          ref={el => {
            tabRefs.current[index] = el;
          }}
          tab={tab}
          isActive={currentTab === tab.value}
          fullWidth={fullWidth}
          onClick={() => onTabChange(tab.value)}
        />
      ))}
    </div>
  );
};
